import WorkspaceLogoBase from './WorkspaceLogo'
import WorkspaceLogoIcon from './WorkspaceLogoIcon'
import { Wrapper, FirstLetter } from './WorkspaceLogo.styles'

export { Wrapper, FirstLetter }

export const WorkspaceLogo = Object.assign(WorkspaceLogoBase, {
  Icon: WorkspaceLogoIcon,
})
